var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app container-md"},[_c('div',{staticClass:"NavHeader"},[_c('NavHeader')],1),_c('div',{ref:"app_content",staticClass:"app_content"},[_c('router-view'),_c('right-menu'),_c('NavFooter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }